import React from 'react';
import Dict from 'dict-lib';
import {deleteEntry} from './EntryActions';
import {getRootEntryId, removeTab} from './../../LexemePage';
import {Button, Row, Col} from 'react-bootstrap';
import '../../../../_css/dictionary/lexemeParts/lexemeTitle.module.css';
import './../../../../_css/lexeme.css';
import {SCSubmitButton} from "../../../../dict-components/submitButton/SCSubmitButton";

export class EntryDelete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: this.props.additionalData.isPoly  ? this.props.item.ids : this.props.additionalData.isExternalDict ? this.props.item.id : getRootEntryId()
        };

        this._handleRemove = this._handleRemove.bind(this);
    }

    _handleRemove() {
        const isExternalDict = typeof this.props.additionalData.isExternalDict !== 'undefined' && this.props.additionalData.isExternalDict === 'true';
        deleteEntry(this.state.id, this.props.additionalData.isPoly, isExternalDict);
    }

    render() {

        var form = this.props.additionalData.isPoly ? this.props.item.form : (this.props.item.lexeme_data.root_entry_form).toUpperCase();

        var message = 'ASK_DELETE_LEXEME'
        if (this.props.additionalData.isPoly)
            message = 'ASK_DELETE_POLY';
        else if (this.props.additionalData.isExternalDict) {
            message = 'ASK_DISCONNECT_EXTERNAL_LEXEME';
        }


        return <div className="entry-delete">
            <Row>
                <Col lg={9} md={9} className="popup-label"><strong>{form + ": "}</strong>{Dict.t(message)}</Col>
                <Col lg={3} md={3}>
                    <SCSubmitButton onClick={this._handleRemove} text={Dict.t('YES')}/>
                </Col>
            </Row>
        </div>;
    }

}
